/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/3 3:07 下午
*/
import request from '@/utils/request'

// 获取列表
export function getSystemConfig() {
    return request({
        url: '/agent/systemConfig',
        method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/app.js